export const walletServicesURL = "wallet-services/";
export const backtestServicesURL = "backtest_services/";
